import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic, Button } from '@mitchell/react.component.ux';
const THUMBSUP_GREEN = '#57b808';
const ALERT_YELLOW = '#ffc700';
export const StyledHeaderContainer = styled.div `
	position: relative;
	top: ${Magnetic.menuPosition};
	z-index: 10;
	color: white;
	text-align: center;
`;
// overflow: hidden;
export const StyledCameraFullView = styled(Grid) `
	position: relative;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	box-sizing: border-box;
	overflow: hidden;
	aspect-ratio: ${(props) => props.aspectratio};
`;
export const StyledCameraGrid = styled(Grid) `
	height: 100%;
	color: ${Magnetic.colorWhite};
`;
export const StyledImageAnalysisMessage = styled(Grid) `
	background-color: rgba(0, 0, 0, 0.5);
	color: ${Magnetic.colorWhite};
	padding: ${Magnetic.spacer04} ${Magnetic.spacer08};
	text-align: center;
	z-index: 999;
	position: relative;
	width: 100%;
	margin: auto;
	font-size: ${Magnetic.fontSize18};
	align-items: baseline;
	@media (max-width: 768px) {
		font-size: ${Magnetic.fontSize14};
	}
	@media (max-width: 480px) {
		font-size: ${Magnetic.fontSize12};
	}
`;
export const StyledVideo = styled('video') `
	height: 100%;
	width: 100%;
	max-width: 100%;
	max-height: 100%;
	object-fit: cover;
	display: block;
	background-color: ${Magnetic.colorBlack};
`;
export const StyledIconImage = styled('span') `
	width: 15px;
	height: 15px;
	margin-right: ${Magnetic.spacer08};

	&.mi-icon-alert-filled-circle {
		line-height: 1.5;
		color: ${ALERT_YELLOW};
	}

	&.mi-icon-thumbsup {
		line-height: 1.5;
		color: ${THUMBSUP_GREEN};
	}
`;
export const StyledGridWebCamWrapper = styled(Grid, {
    shouldForwardProp: prop => prop !== 'isFlashActive'
}) `
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	margin: auto;
	touch-action: none;
	overscroll-behavior: contain;
	overflow: hidden;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		pointer-events: none;
		background: ${props => props.isFlashActive
    ? 'radial-gradient(circle at center, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.9) 45%, rgba(255, 255, 255, 0.7) 100%)'
    : 'radial-gradient(circle at center, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 100%)'};
		opacity: ${props => (props.isFlashActive ? 0.4 : 0)};
		transition: opacity 200ms ease-out;
	}

	video {
		filter: ${props => (props.isFlashActive ? 'brightness(1.2) saturate(1.05)' : 'none')};
		transition: filter 200ms ease-out;
	}
`;
export const StyledCameraButtonsView = styled(Grid) `
	width: 100%;
	padding: 0px ${Magnetic.spacer08} ${Magnetic.spacer16};
	z-index: 999;
	position: fixed;
	bottom: 0;

	button {
		border-radius: 50%;
		height: 50px;
		width: 50px;
		@media (max-width: 768px) {
			font-size: ${Magnetic.fontSize16};
		}
		@media (max-width: 480px) {
			font-size: ${Magnetic.fontSize14};
		}

		span {
			padding: 0;
		}
	}
`;
export const StyledHiddenInput = styled.input `
	display: none;
`;
export const StyledImage = styled.img `
	height: 30px;
	width: 30px;
	@media (max-width: 768px) {
		height: 25px;
		width: 25px;
	}
`;
export const StyledCaptureButton = styled(Button) `
	border-radius: 50%;
	height: 50px;
	width: 50px;
	color: ${Magnetic.buttonFlatOnDarkFontColor};
	background-color: ${Magnetic.buttonPrimaryBackgroundColor};
	padding: 0;
	@media (max-width: 768px) {
		font-size: ${Magnetic.fontSize16};
	}
	@media (max-width: 480px) {
		font-size: ${Magnetic.fontSize14};
	}
`;
export const StyledIconWrapper = styled('div') `
	width: 50px;
	height: 50px;
	background: ${Magnetic.linkFontColorWhite};
	border: none;
	border-radius: 50%;
	margin-left: ${Magnetic.spacer04};
	padding: ${Magnetic.spacer12};
	font-size: ${Magnetic.fontSize26};
	@media (max-width: 768px) {
		padding: ${Magnetic.spacer14};
	}
`;
export const StyledContentWrapper = styled('div') `
	background-color: ${props => props.bgcolor || Magnetic.colorBlack};
	min-height: 100vh;
`;
export const HeaderContainer = styled.div `
	position: relative;
`;
export const HeaderSubTitle = styled.h2 `
	background-color: rgba(0, 0, 0, 0.5);
	color: ${Magnetic.colorWhite};
	padding: ${Magnetic.spacer16} ${Magnetic.spacer08};
	text-align: center;
	z-index: 999;
	position: relative;
	width: 100%;
	margin: auto;
	font-size: ${Magnetic.fontSize20};
	@media (max-width: 768px) {
		font-size: ${Magnetic.fontSize18};
	}
	@media (max-width: 480px) {
		font-size: ${Magnetic.fontSize14};
	}
`;
export const HeaderDoneButtonWrapper = styled.div `
	display: flex;
	justify-content: flex-end;
	width: 100%;
	padding: ${Magnetic.spacer08} ${Magnetic.spacer08} 0;
	& > button {
		width: auto;
		z-index: 1;
		padding: 0 ${Magnetic.spacer12};
	}
`;
//# sourceMappingURL=IntelligentImageAnalyzerCamera.style.js.map